import React from "react";
import { MapPin, Lightbulb, Target } from "lucide-react";
import BLabsLogo from "./BLabsLogo";

const AboutUs = () => {
  const values = [
    {
      icon: MapPin,
      title: "Norsk selskap",
      description: "Lokalt forankret med fokus på det norske markedet",
    },
    {
      icon: Lightbulb,
      title: "Enkle løsninger",
      description: "Vi tror på smarte, brukervennlige produkter",
    },
    {
      icon: Target,
      title: "Fremtidsrettet",
      description: "Bygger fremtidens ladeløsninger for sosiale møteplasser",
    },
  ];

  return (
    <section
      id="about"
      className="py-24 md:py-32 bg-[#121212]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
              Om oss
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white mb-6 font-['Outfit']">
              Hvem er vi
            </h2>
            <p className="text-lg text-[#A1A1AA] mb-8 leading-relaxed">
              B-Labs er et norsk teknologiselskap med én klar visjon: Ingen skal
              gå tom for strøm. Vi leverer smarte ladeløsninger til sosiale
              møteplasser over hele Norge.
            </p>
            <p className="text-lg text-[#A1A1AA] mb-10 leading-relaxed">
              Med fokus på enkelhet og kvalitet bygger vi fremtidens
              infrastruktur for mobillading – én stasjon om gangen.
            </p>

            {/* Values */}
            <div className="space-y-6">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4"
                  data-testid={`value-${index + 1}`}
                >
                  <div className="w-12 h-12 bg-[#0A0A0A] border border-white/10 rounded-xl flex items-center justify-center shrink-0">
                    <value.icon className="w-6 h-6 text-[#FFD84D]" />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1 font-['Outfit']">
                      {value.title}
                    </h4>
                    <p className="text-[#A1A1AA]">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#FFD84D]/10 to-transparent rounded-3xl" />
            <div className="relative bg-[#0A0A0A] border border-white/10 rounded-3xl p-8 md:p-12 overflow-hidden">
              {/* Background pattern */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 left-0 w-full h-full" style={{
                  backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
                  backgroundSize: '40px 40px'
                }} />
              </div>

              {/* Logo large */}
              <div className="relative z-10 flex flex-col items-center justify-center min-h-[300px]">
                <BLabsLogo size="xlarge" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
